import { Card } from "@/components/ui/card/Card";
import { Button } from "@/components/ui/button/Button";
import { WORK_STEPS } from "./constants";

export function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="w-full max-w-7xl mx-auto px-5 md:px-8 py-20 sm:py-28 flex flex-col gap-12 sm:gap-16 scroll-mt-24"
    >
      <div className="flex flex-col gap-3.5 items-center justify-center">
        <h2 className="text-5xl  font-medium text-text-primary tracking-tight leading-tight">
          See how Repayas works
        </h2>
        <p className="text-lg md:text-xl text-text-secondary">
          Three simple checks before money leaves your business.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {WORK_STEPS.map((step) => (
          <Card
            key={step.number}
            as="article"
            hoverable
            className="flex flex-col items-start"
          >
            <div
              className="inline-flex items-center justify-center bg-accent text-text-primary text-xs font-bold px-3.5 py-1.5 rounded-full mb-6 select-none"
              aria-hidden="true"
            >
              {step.number}
            </div>

            {/* Title */}
            <h3 className="text-xl md:text-2xl font-medium text-text-primary leading-snug mb-3 tracking-tight">
              {step.title}
            </h3>

            {/* Description */}
            <p className="text-sm sm:text-base text-text-secondary leading-relaxed font-normal">
              {step.description}
            </p>
          </Card>
        ))}
      </div>

      {/* CTA Button */}
      <div className="flex justify-center mt-2 sm:mt-4">
        <Button
          variant="primary"
          size="md"
          href="/signup"
          id="how-it-works-cta-start-trial"
        >
          Start free trial
        </Button>
      </div>
    </section>
  );
}

export default HowItWorks;
